import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs'
import { catchError, map, take, timeout } from 'rxjs/operators'
import { RolesType } from 'src/app/features/role/role'
import { userRoleActions } from 'src/app/features/role/user-role/user-role.actions'
import { AppState, selectRouterState } from '../core.state'
import { NotificationService } from '../notification.service'
import { authActions } from './auth.actions'
import { authSelectors } from './auth.selectors'
import { oidcSelectors } from './oidc/oidc.selectors'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([
      this.store.select(authSelectors.selectMember),
      this.store.select(oidcSelectors.selectProviderSettings)
    ]).pipe(
      map(([member, isOidc]) => {
        if (!member) {
          this.store
            .select(selectRouterState)
            .pipe(take(1))
            .subscribe((routerState) =>
              this.store.dispatch(
                authActions.setRedirectUrl({
                  redirectUrl: routerState.state.url
                })
              )
            )

          return this.router.parseUrl('/pages/login')
        }

        if (
          !Boolean(
            member.userRoles.find((role) =>
              [RolesType.ADMIN, RolesType.EDITOR].includes(role?.role?.type)
            )
          )
        ) {
          this.store.dispatch(authActions.logout())
          return this.router.parseUrl('/pages/login')
        }

        return true
      }),
      take(1)
    )
  }
}
